module.exports = __webpack_public_path__ + "assets/img/av2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lectors/av2.png
// module id = 1951
// module chunks = 0